import React from 'react';
import {NotFoundIcon} from "presentation/common/components/style-guide/icons";

export const NotFoundDocs = () => (
  <div className="w-full h-full p-4 flex justify-center items-center flex-col text-center">
    <NotFoundIcon />
    <h3 className="p-4 text-center" style={{ color: '#505050' }}>
      No se han encontrado resultados para su búsqueda.
    </h3>
  </div>
);
